module.exports = __webpack_public_path__ + "fonts/montserrat-v12-latin-600.15c24f71.woff2";